<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-home-experience-automation-panel-bes-bas-summary" v-loading="loading" element-loading-text="Loading...">
    <wy-exp-and-auto-header
      :selecteddatePeriodRange="viewByHeader"
      :showChartViewBy="showChartViewBy"
      ref="panelHeader"
      :panelHeaderData="pannelData"
      :controller="module"
      :graphType="type"
      :panelTitleNoBracket="panelTitle"
      :panelTitle="panelTitle"
    />

    <div v-if="sectionData && sectionData.pieChartData && sectionData.pieChartData.length > 0" class="pie-chart-flex-container">
      <!-- <div v-if="true" class="pie-chart-flex-container"> -->

      <wy-home-exp-pie-chart
        :targetKey="'bes'"
        :title="sectionData.pieChartData[0].key.toUpperCase()"
        class="pie-chart-section left"
        ref="pieChartBes"
        :chartId="panelId + '_' + sectionData.pieChartData[0].key + '_pie_chart'"
        :pieChartData="sectionData.pieChartData[0]"
      />
      <wy-home-exp-pie-chart
        :targetKey="'bas'"
        :title="sectionData.pieChartData[1].key.toUpperCase()"
        class="pie-chart-section right"
        ref="pieChartBas"
        :chartId="panelId + '_' + sectionData.pieChartData[1].key + '_pie_chart'"
        :pieChartData="sectionData.pieChartData[1]"
      />
    </div>

    <div v-else class="no-data-flex">
      <div style="width: 100%; text-align: center;">
        <img class="no-data-image" src="../../../../../src/assets/icons/icon_performance_no_data.svg" alt="no data icon" />
        <!-- <img class="no-data-image" src="../../../assets/icons/icon_no_data.svg" alt="no data icon"> -->
      </div>
      <span class="no-data-text">No data found</span>
      <span class="no-data-text-small">Try adjusting your date range or filters to find the information you're looking for.</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../../../library/wy-utils.js';
import WyPanelHeader from '../../wy-exp-and-auto-header.vue';
import WyPanelPieChart from '../../panel-charts/wy-home-exp-pie-chart.vue';
import WyHomeUtils from '../../utils/wy-home-utils.js';

export default Vue.extend({
  name: 'wy-home-experience-automation-panel-bes-bas-summary',
  props: ['controller'],
  components: {
    'wy-exp-and-auto-header': WyPanelHeader,
    'wy-home-exp-pie-chart': WyPanelPieChart,
  },

  data() {
    return {
      module: this,
      loading: false,
      templateData: {},
      rawData: {},
      showChartViewBy: false,
      pannelData: {},
      startDate: '',
      type: 'pie',
      viewByHeader: 'Last 7 days',
      endDate: '',
      sectionData: {},
      lineChartData: {},
      panelId: 'demoBotNumOneLast30days',
      panelTitle: 'BES & BAS',
      dataIndex: 0,
      dateRange: 'day',
    };
  },

  computed: {
    ...mapGetters(['dataModel', 'companyConfig', 'legendDefaultColors']),
  },

  methods: {
    ...mapActions(['fetchBesBasPieChart']),

    async changeDatePeriod(sDate, eDate, dateRangeType) {
      this.startDate = sDate;
      this.endDate = eDate;
      this.viewByHeader = dateRangeType;
      await this.handleFilterChange();
    },

    async handleFilterChange() {
      if ((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.loading = true;
        // DEMO: for demo purpose
        const demoConfigs = this.companyConfig.demoConfigs || {};
        const demoDateRange = demoConfigs[this.viewByHeader];
        if (demoDateRange && demoDateRange.startDate && demoDateRange.endDate) {
          this.startDate = demoDateRange.endDate;
          this.endDate = demoDateRange.startDate;
        }
        this.rawData = await this.fetchBesBasPieChart([this.controller.selection, this.startDate, this.endDate]);
        // this.rawData.bes = -1;
        // this.rawData.bas = -1;
        // this.rawData = {}
        if (
          this.rawData.totalBotSummaryMetric &&
          Object.keys(this.rawData.totalBotSummaryMetric).length > 0 &&
          (this.rawData.totalBotSummaryMetric.bes != -1 || this.rawData.totalBotSummaryMetric.bas != -1)
        ) {
          this.rawData = this.rawData.totalBotSummaryMetric;
          this.templateData = WyHomeUtils.getHomeExpAndAutoDemoBot1Last30DaysData();
          this.sectionData.pieChartData = [];
          let besPieData = {
            key: 'bes',
            displayValue: WyUtils.bigNumberFormatter(this.rawData.bes),
            legends: ['Experience', 'Non-experience'],
            legendColors: ['#8E88DC', '#CCC'],
            percent: [this.rawData.bes, 100 - this.rawData.bes],
            title: 'BES',
            subtitle: 'Experience',
            tooltips: 'tooltips',
            values: [this.rawData.bes, 100 - this.rawData.bes],
          };
          this.sectionData.pieChartData.push(besPieData);

          let basPieData = {
            key: 'bas',
            displayValue: WyUtils.bigNumberFormatter(this.rawData.bas),
            legends: ['Automation', 'Non-automation'],
            legendColors: ['#E5996D', '#CCC'],
            percent: [this.rawData.bas, 100 - this.rawData.bas],
            title: 'BAS',
            subtitle: 'Automation',
            tooltips: 'tooltips',
            values: [this.rawData.bas, 100 - this.rawData.bas],
          };
          this.sectionData.pieChartData.push(basPieData);
          setTimeout(() => {
            if (this.$refs.pieChartBes && this.$refs.pieChartBes.buildChart) {
              this.$refs.pieChartBes.buildChart();
            }
            if (this.$refs.pieChartBas && this.$refs.pieChartBas.buildChart) {
              this.$refs.pieChartBas.buildChart();
            }
            this.loading = false;
          }, 800);
        } else {
          this.loading = false;
          this.pannelData = {};
          this.sectionData = {};
        }
      }
    },
  },
  async created() {
    await this.handleFilterChange();
    // this.$el.classList.add("full-size");
  },
});
</script>

<style lang="scss">
.wy-home-experience-automation-panel-bes-bas-summary {
  .el-loading-mask {
    // height: 656px !important;
    top: 65px !important;
  }
  .pie-chart-flex-container {
    display: flex;
    .pie-chart-section {
      width: 50%;
      display: flex;
      margin-top: 10px;
      align-items: center;
      flex-direction: column;
    }
  }
}
</style>
